<template>
  <div class="row documents-settings">
    <div class="col">
      <div class="row">
        <div class="col mx-2">
          <form class="form-inline py-2 justify-content-start">
            <div class="d-flex align-items-center">
              <button type="button" class="btn btn-back btn-lg" @click="$router.push('/settings')">
                <i class="fa fa-angle-left px-1"></i>
              </button>
              <h2 class="ml-2">Настройки документов</h2>
            </div>
          </form>
        </div>
      </div>
      <div class="row">
        <div class="col text-right">
          <button class="btn btn-outline-primary" @click="addDocPattern">
            <i class="ico ico-plus mr-2"></i>Добавить шаблон
          </button>
        </div>
      </div>
      <div class="row mt-5">
        <div class="ml-auto col-3 text-right">
          <div class="input-group with-clear-icon">
            <input type="text" class="form-control" v-model="searchText" />
            <i class="ico ico-close" @click="clearSearchText" v-if="searchText.length > 0"></i>
            <div class="input-group-append">
              <span class="input-group-text">
                <i class="fa fa-search"></i>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="row documents-settings__table">
        <div class="col">
          <table class="table clients-table mt-4">
            <thead>
              <tr>
                <th
                  v-for="item in tableHeaderItems"
                  :key="item.id"
                  v-show="item.isVisible"
                  :class="{'sort-asc': item.name === sortFieldName && sortType === 'ASC',
                        'sort-desc': item.name === sortFieldName && sortType === 'DESC',
                        'sort': item.name !== sortFieldName && item.name !== 'actions' }"
                  :style="{'width': item.width * 100 / tableHeaderItems.map(x=>x.width).reduce((a, b) => a + b) + '%'}"
                  @click="sortDocuments(item.name)"
                >
                  <div class="table-th">{{ item.viewName }}</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="documentLayout in filteredDocumentLayouts" :key="documentLayout.id">
                <td v-for="item in tableHeaderItems" :key="item.name">
                  <template v-if="item.name === 'status'">
                    <div class="td-content td-content-lg" :title="documentLayout[item.name].value ? 'активный': 'не активный'">
                      <div class="documents-settings__property-pill" v-if="documentLayout[item.name].value">
                        <span>активный</span>
                      </div>
                      <div class="documents-settings__property-pill documents-settings__property-pill--disabled"  v-if="!documentLayout[item.name].value">
                        <span>не активный</span>
                      </div>
                    </div>
                  </template>
                  <template v-else-if="item.name === 'actions'">
                    <router-link
                      tag="button"
                      type="button"
                      class="btn btn-sm btn-primary px-3"
                      :to="`/settings/documents/edit/${documentLayout.id}`"
                      @click.prevent
                    >
                      <i class="fa fa-pencil"></i>
                    </router-link>
                  </template>
                  <template v-else>{{documentLayout[item.name].value}}</template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce, sortBy } from 'lodash'
import api from '../../../api'
import moment from 'moment'

export default {
  name: 'DocumentsIndex',
  data () {
    return {
      searchText: '',
      lazySearchText: '',
      documentLayouts: [],
      sortFieldName: 'number',
      sortType: 'ASC',
      tableHeaderItems: []
    }
  },
  computed: {
    sortedDocumentLayouts () {
      const sortedDocumentLayouts = sortBy(this.documentLayouts, x => {
        return x[this.sortFieldName].sortValue
      })

      if (this.sortType === 'DESC') {
        return sortedDocumentLayouts.reverse()
      }

      return sortedDocumentLayouts
    },
    filteredDocumentLayouts () {
      if (this.lazySearchText) {
        return this.sortedDocumentLayouts.filter(f =>
          Object.values(f).some(
            x =>
              x.searchValue &&
              x.searchValue.toLowerCase().indexOf(this.lazySearchText) >= 0
          )
        )
      }
      return this.sortedDocumentLayouts
    }
  },
  watch: {
    searchText: debounce(function (newValue) {
      this.lazySearchText = newValue.toLowerCase()
    }, 300)
  },
  async created () {
    await this.setDocumentLayouts()
    this.setTableHeader()
  },
  methods: {
    async setDocumentLayouts () {
      const resp = await api.get.documentLayouts()
      this.documentLayouts = resp.data.data.layouts.map(x => {
        const dateEditValue = moment(x.mtime)
        const dateEdit = dateEditValue.format('DD.MM.YYYY HH:mm')
        const description = x.description ? x.description : '-'

        return {
          id: x.id,
          number: {
            value: x.local_id,
            sortValue: x.local_id,
            searchValue: x.local_id.toString()
          },
          name: {
            value: x.name,
            sortValue: x.name,
            searchValue: x.name
          },
          description: {
            value: description,
            sortValue: description,
            searchValue: description
          },
          editDate: {
            value: dateEdit,
            sortValue: dateEditValue,
            searchValue: dateEdit
          },
          status: {
            value: x.enabled,
            sortValue: x.enabled,
            searchValue: ''
          }
        }
      })
    },
    addDocPattern () {
      this.$router.push('/settings/documents/add')
    },
    clearSearchText () {
      this.searchText = ''
    },
    setTableHeader () {
      this.tableHeaderItems = [
        {
          name: 'number',
          viewName: 'Номер',
          width: 40,
          isVisible: true
        },
        {
          name: 'name',
          viewName: 'Название',
          width: 80,
          isVisible: true
        },
        {
          name: 'description',
          viewName: 'Описание',
          width: 120,
          isVisible: true
        },
        {
          name: 'editDate',
          viewName: 'Дата редактирования',
          width: 80,
          isVisible: true
        },
        {
          name: 'status',
          viewName: 'Статус',
          width: 100,
          isVisible: true
        },
        {
          name: 'actions',
          viewName: '',
          width: 40,
          isVisible: true
        }
      ]
    },
    sortDocuments (fieldName) {
      if (fieldName === 'actions') return
      if (fieldName === this.sortFieldName) {
        this.sortType = this.sortType === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sortFieldName = fieldName
        this.sortType = 'ASC'
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$eventBus.$emit('pageHeaderChange', 'настройки документов')
    })
  }
}
</script>

<style lang="scss">
.documents-settings{
  &__property-pill {
    margin-top: 15px;
    display: inline-block;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    text-align: center;
    width: 125px;
    height: 17px;
    color: #fff;
    background-color: #28bd8b;
    border-radius: 4px;

    &--disabled {
      background-color: #f34d65;
    }
  }
}
</style>
